import { render, staticRenderFns } from "./LinkBoxPreview.vue?vue&type=template&id=197314ea&scoped=true&"
import script from "./LinkBoxPreview.vue?vue&type=script&lang=js&"
export * from "./LinkBoxPreview.vue?vue&type=script&lang=js&"
import style0 from "./LinkBoxPreview.vue?vue&type=style&index=0&id=197314ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197314ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
